import { EventIncidentsQueue } from '@collector/desktop-feature-incidents-queue-core'
import { useKeepAlive } from '@collector/shared-domain'
import { injectRequestUrl } from '@collector/shared-ui-domain'
import { sportsApiClient } from '@desktop/globalState/sportsApiClient'
import { useEvent } from '@desktop/views/Relation/composables/useEvent'

import { provideEventIncidentsQueue } from '.'

type Params = {
  eventIncidentsQueue: EventIncidentsQueue
}

/**
 * Vue provide/inject - provide dependencies for all sports
 *
 * You cant use async/await here - Vue will show warning and won't resolve value provided with inject
 */
export const provideAndInitRelation = (params: Params) => {
  const { event } = useEvent()

  provideEventIncidentsQueue(params.eventIncidentsQueue)

  const requestUrl = injectRequestUrl()
  useKeepAlive(event, sportsApiClient.Events.KeepAlive.post, requestUrl)
}
